import { render, staticRenderFns } from "./contract-information.vue?vue&type=template&id=a0945ac6&"
import script from "./contract-information.vue?vue&type=script&lang=ts&"
export * from "./contract-information.vue?vue&type=script&lang=ts&"
import style0 from "./contract-information.vue?vue&type=style&index=0&id=a0945ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports